




















































































import { Vue, Component } from 'vue-property-decorator';
import Upload from '../components/NewUploader.vue';
import Upload1 from '../components/NewUploader1.vue';
import Upload2 from '../components/NewUploader2.vue';
import { isWeiXin } from '@/common/ts/common';
import { save } from '../api';
import { Field, Toast, DropdownMenu, DropdownItem } from 'vant';
Vue.use(Field)
  .use(DropdownMenu)
  .use(DropdownItem);
@Component({
  components: {
    Upload,
    Upload1,
    Upload2,
  },
})
export default class Save extends Vue {
  works: string = '';
  author: string = '';
  tel: string = '';
  introduction: string = '';
  img: any = [];
  video: any = [];
  value: number = 0;
  canclick: boolean = true;
  option1: any = [
    { text: '作品类型*', value: 0 },
    { text: '图片', value: 1 },
    { text: '视频', value: 2 },
  ];
  created() {
    if (isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      const userLogin = window.gettoken() && window.gettoken() !== 'null';
      if (window.udid && !userLogin) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
        return false;
      }
    }
  }
  async upImg() {
    if (this.value === 1) {
      this.img = (await (this.$refs
        .upload1 as Upload).uploadToOss()) as string[];
    } else if (this.value === 2) {
      this.img = (await (this.$refs
        .upload2 as Upload1).uploadToOss()) as string[];
    }
  }

  async upVideo() {
    this.video = (await (this.$refs
      .video as Upload2).uploadToOss()) as string[];
  }
  WechatLogin() {
    const unionid = window.localStorage.getItem('unionid');
    if (!unionid) {
      if (isWeiXin() || !window.udid) {
        const appId = 'wx1949ed4a473b87ed';
        location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
          location.href,
        )}`;
      }
    }
  }
  async submit() {
    if (!this.canclick) {
      return false;
    }
    if (!this.value) {
      Toast('请选择作品类型');
      return false;
    } else if (!this.works) {
      Toast('请输入作品名称');
      return false;
    } else if (!this.author) {
      Toast('请输入姓名');
      return false;
    } else if (!this.tel) {
      Toast('请输入手机号');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.tel)) {
      Toast('手机号错误');
      return false;
    } else if (!this.introduction) {
      Toast('请输入创意说明');
      return false;
    } else if (!this.img.length) {
      Toast('请上传照片');
      return false;
    } else if (!this.video.length && this.value === 2) {
      Toast('请上传视频');
      return false;
    } else {
      this.canclick = false;
      const data = {
        unionid: window.localStorage.getItem('unionid'),
        udid: window.udid,
        appkey: window.appkey,
        token: window.gettoken(),
        workType: this.value,
        title: this.works,
        name: this.author,
        phone: this.tel,
        cover: this.img.join('|'),
        explain: this.introduction,
        video: this.video.join('|'),
      };
      const res: any = await save(data);
      if (res.code === 200) {
        Toast(`${res.msg}`);
        setTimeout(() => {
          this.canclick = true;
          this.$router.go(0);
        }, 2000);
      } else if (res.code === 505) {
        this.canclick = true;
        localStorage.removeItem('unionid');
        window.location.reload();
      } else {
        this.canclick = true;
        Toast(`${res.msg}`);
      }
    }
  }
}
